export class Search {
	static readonly type = '[mortgageBrokerSearch] search';
	constructor(public searchTerm: string) {}
}
